const formDateTimeFromGraphQL = (date: string) => {
  const cleanedDateStr = date.replace(/\[.*\]$/, '');
  const dateObj = new Date(cleanedDateStr);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
};

export default formDateTimeFromGraphQL;